<template>
  <el-dialog :visible.sync="visible" width="680px" @open="visibleChange(true)" @close="visibleChange(false)" :close-on-click-modal="false">
    <template #title>
      <div class="title-header">
        <div class="header-text">文案包选择</div>
        <div v-show="selection.length > 0" class="nums">已选{{ selection.length }}个</div>
      </div>
    </template>

    <div class="top-form">
      <el-form ref="formInline" :model="formItem" inline @submit.native.prevent="() => {}">
        <el-form-item>
          <ThrottleSelector
            :popper-append-to-body="false"
            v-model="formItem.opId"
            @change="newQuery"
            @on-clear="newQuery"
            :list="PTOM_USERS"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="formItem.keyword"
            placeholder="输入文案包名称搜索"
            clearable
            style="width: 260px"
            @keyup.enter.native="newQuery"
            @clear="newQuery"
          >
            <el-button slot="append" icon="el-icon-search" @click="newQuery"></el-button>
          </el-input>
        </el-form-item>
      </el-form>

      <div class="btns">
        <el-button type="text" class="btn refresh" @click="query">
          <span class="el-icon-loading" v-if="tableLoading"></span>
          <span>刷新</span>
        </el-button>
        <el-button type="text" class="btn add" @click="showAddTitle">+新增文案包</el-button>
      </div>
    </div>

    <div class="main-table">
      <div style="position: relative" v-loading="tableLoading">
        <el-table
          :data="tableData"
          :height="260"
          border
          ref="table"
          class="common-el-table-styles"
          @selection-change="onTableSelectChange"
          @row-click="onTableRowClick"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="packName" show-overflow-tooltip label="文案包名称" width="88"> </el-table-column>
          <el-table-column prop="mediaName" show-overflow-tooltip label="媒体" width="80"> </el-table-column>
          <el-table-column prop="content" label="文案内容">
            <template slot-scope="{ row }">
              <p v-for="(text, idx) in row.content" :key="idx">{{ text }}；</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="{ row }">
              <el-button type="text" @click.stop="onRowEdit(row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pager">
        <el-pagination
          layout="total, prev, pager, next"
          background
          :current-page.sync="pager.page.pageIndex"
          :page-size="pager.page.pageSize"
          :total="pager.total"
          @current-change="query"
        />
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取消</el-button>
      <el-button @click="onConfirm" type="primary">确定</el-button>
    </div>

    <!-- 新增文案包弹窗 -->
    <AddTitlePackage v-model="isShowAddTitleModal" :default-media="mediaId" ref="titlePackage" @added="newQuery" />
  </el-dialog>
</template>
<script>
import AddTitlePackage from './title-add.vue'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { getTitlePackages } from '@/api/common.model.js'
import { MEDIAS } from './consts/index.js'
import { MEDIAS as MEDIAS_ENUM } from '@/common/js/constants.js'
import { PTOM_USERS, initPageData } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS])
export default {
  components: {
    AddTitlePackage,
    ThrottleSelector
  },
  props: {
    value: {
      type: Boolean
    },
    limit: {
      type: Number,
      default: 100
    },
    opId: {
      type: Number
    },
    mediaId: {
      type: Number,
      default: MEDIAS_ENUM.TOUTIAO
    },
    beforeConfirm: {
      type: Function
    }
  },
  data() {
    return {
      pager: {
        total: 0,
        page: {
          pageIndex: 1,
          pageSize: 10
        }
      },
      selection: [],
      tableLoading: false,
      isShowAddTitleModal: false,
      tableData: [],
      formItem: {
        keyword: '',
        opId: ''
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  created() {
    // this.query()
  },
  methods: {
    /**
     * @description: 查新文案包列表
     * @return {*}
     */
    query() {
      this.tableLoading = true
      getTitlePackages({
        ...this.pager.page,
        ...this.formItem,
        mediaId: this.mediaId
      }).then((data) => {
        if (!data || !data.list) return
        this.tableData = data.list.map((item) => {
          const mediaIds = item.mediaIds.split(',')
          const media = MEDIAS.filter((m) => mediaIds.includes(String(m.value)))
          const mediaName = media.map((m) => m.label).join(',')
          // 根据媒体id获取媒体名称
          return {
            ...item,
            mediaName,
            content: JSON.parse(item.content)
          }
        })
        this.tableLoading = false
        this.pager.total = data.page_info.total_number
      })
    },

    /**
     * @description: 页码重置后搜索
     * @return {*}
     */
    newQuery() {
      this.$nextTick(() => {
        this.pager.page.pageIndex = 1
        this.query()
      })
    },
    /**
     * @description: 编辑文案条目
     * @param {*} row 当前编辑的条目
     * @return {*}
     */
    onRowEdit(row) {
      this.$refs.titlePackage.setContent(row)
      this.isShowAddTitleModal = true
    },
    /**
     * @description: 点击行选中
     * @param {*} row
     * @return {*}
     */
    onTableRowClick(row) {
      if (this.limit === 1) {
        this.$refs.table.clearSelection()
      }
      this.$refs.table.toggleRowSelection(row)
    },
    /**
     * @description: 获得当前全部的选中项
     * @param {*} selection
     * @return {*}
     */
    onTableSelectChange(selection) {
      // tips: 如果要做成每页都记住当前页的选中项，那this.selection要改成{}形式，以pageIndex为key来记录
      this.selection = selection
    },
    /**
     * @description: 显示新增文案modal
     * @return {*}
     */
    showAddTitle() {
      this.isShowAddTitleModal = true
    },
    /**
     * @description: 人员选择后触发的回调
     * @param {*} id
     * @return {*}
     */
    changeOperator({ id }) {
      if (id) {
        this.formItem.opId = id
        this.newQuery()
      }
    },
    /**
     * @description: 确认选择，至少选择一项
     * @return {*}
     */
    async onConfirm() {
      try {
        if (this.beforeConfirm && typeof this.beforeConfirm === 'function') {
          await this.beforeConfirm(this.selection)
        }
        const len = this.selection.length
        if (len) {
          if (len > this.limit) {
            return this.$Message.warning(`最多选择${this.limit}个文案包`)
          }
          this.$emit('confirm', this.selection)
          this.closeModal()
        } else {
          this.$Message.warning('请至少选择一个文案包')
        }
      } catch (e) {
        console.log('beforeConfirm error output: ', e)
        this.$Message.warning(e.message)
      }
    },
    closeModal() {
      this.$refs.table.clearSelection()
      this.visible = false
    },
    visibleChange(visible) {
      if (visible) {
        this.formItem.opId = this.opId
        this.newQuery()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-header {
  display: flex;
  align-items: center;
  .header-text {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }
  .nums {
    margin-left: 10px;
  }
}
.top-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-form-item {
    margin-bottom: 0;
  }
}
.main-table {
  margin-top: 10px;
  .pager {
    margin-top: 10px;
    text-align: right;
  }
}
.dialog-footer {
  text-align: right;
}
</style>
